// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { requestRmaProductListStyles } from "@conklin/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...mergeWithCss(cartLineSharedStyles.productDescription, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 225px;
            width: 225px;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 100px;
            margin-right: auto;
            ${xScreen("lte", "sm")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
    errorProps: {
        css: css`
            white-space: nowrap;
            line-height: 22px;
        `,
    },
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-bottom: 25px;
    `,
};

requestRmaProductListStyles.cartLineContainerStyles = {
    description: {
        css: css`
            gap: 8px;
            ${xScreen("lte", "md")} {
                grid-column: 2 / 6;
            }
            ${xScreen("lte", "sm")} {
                grid-column: 2 / 7;
            }
        `,
    },
    actions: {
        css: css`
            grid-column: 3 / 6;
            justify-content: end;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 7;
                justify-content: start;
            }
        `,
    },
    inventory: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 6;
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 5 / 7;
            }
        `,
    },
    remove: {
        css: css`
            display: none;
        `,
    },
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...cartLineSharedStyles.productPrice?.price?.priceText,
};

requestRmaProductListStyles.unitOfMeasure = {
    ...cartLineSharedStyles.productPrice?.price?.unitOfMeasure?.unitOfMeasureText,
};

requestRmaProductListStyles.orderLineCardImage = {
    css: css`
        ${cartLineSharedStyles?.productImage?.linkWrappingImage?.css}
    `,
};

requestRmaProductListStyles.productQty = {
    valueText: {
        variant: "h6",
        css: css`
            margin-bottom: 0;
        `,
    },
};

requestRmaProductListStyles.productAvailability = {
    errorWrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    messageGridItem: {
        css: css`
            &:not(:empty) {
                margin-bottom: 12px;
            }
        `,
    },
};

requestRmaProductListStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 8px;
        @media print {
            display: block;
        }
    `,
};
